import { axiosInstance } from './apiCommon';

/**
 * The company's own switches (mirrors EPDServices.Application/Features/CompanyFeatureFlags/CompanyFeatureFlagsModel.cs).
 * isDynamicFormsEnabled is the company switch only - combine it with the global
 * `dynamic-forms.portal` flag before offering Dynamic Forms.
 */
export interface CompanyFeatureFlagsModel {
  isDynamicFormsEnabled: boolean;
  isReadOnly: boolean;
}

/** 403 when the current user is not in the company (Super Admin passes). */
export const getCompanyFeatureFlags = async (companyId: string): Promise<CompanyFeatureFlagsModel> =>
  (await axiosInstance.get<CompanyFeatureFlagsModel>(`/api/v1/companies/${companyId}/feature-flags`)).data;
